import { render } from "./PlayerTeamTile-v2.vue?vue&type=template&id=28d8f7f2&scoped=true"
import script from "./PlayerTeamTile-v2.vue?vue&type=script&lang=js"
export * from "./PlayerTeamTile-v2.vue?vue&type=script&lang=js"

import "./PlayerTeamTile-v2.vue?vue&type=style&index=0&id=28d8f7f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d8f7f2"]])

export default __exports__